export default "__VITE_ASSET__B6BO2DsO__"